import {createThunk, makeThunkErrorHandler} from '~ui/store/utils';
import {i18n} from '~ui/components/RevisionsPanel/i18n';

const PAGE_SIZE = 20;

interface GetRevisionsArgs {
    pageId: number;
    cursor?: string;
}

export const getRevisions = createThunk(
    'revisions/get',
    async ({pageId, cursor}: GetRevisionsArgs, {extra: {sdk}}) => {
        return sdk.wiki
            .getPageRevisions({
                cursor,
                pageSize: PAGE_SIZE,
                pageId,
            })
            .catch(
                makeThunkErrorHandler({
                    name: 'get-revisions',
                    title: i18n('error-get-revisions-title'),
                }),
            );
    },
);
